import { DASHBOARD_SET_DATA, DASHBOARD_SET_TAG, DASHBOARD_SET_TODAY_DATA, SET_REPORT_OPTIONS, SET_SLOT_UPDATING, SET_ACTIVE_DASHBOARD, SET_REPORT_DASHBOARD_DATA, SET_ALL_REFRESHING, SET_SLOT_DATA, RESET_ACTIVE_DASHBOARD, RESET_DASHBOARD } from './actionType';
import { getStore, setStore } from 'utils/localStorage';
import Enums from 'utils/EnumsManager';
import { setSlotUpdate, setDashboardUpate, setSlotData } from './utils';

const { LocalStorageKeys, Recently } = Enums;
const { dashboardView } = LocalStorageKeys;

const initailState = {
  leads: [],
  accounts: [],
  objects: [],
  activities: [],
  tagView: getStore(dashboardView) ? getStore(dashboardView) : Recently,
  todayNewTotal: {
    leads: 0,
    accounts: 0,
    opportunities: 0,
  },
  reportOptions: [],
  reportActiveDashboard: '',
  reportDashboard: {},
};

const dashboard = (state = initailState, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case DASHBOARD_SET_DATA:
      return Object.assign({}, state, { ...payload.data });

    case DASHBOARD_SET_TAG:
      setStore(dashboardView, payload.value);
      return {
        ...state,
        tagView: payload.value,
      };

    case DASHBOARD_SET_TODAY_DATA:
      return {
        ...state,
        todayNewTotal: {
          ...state.todayNewTotal,
          ...payload.data,
        },
      };

    case SET_REPORT_OPTIONS:
      const { options } = action.payload;
      return {
        ...state,
        reportOptions: [
          ...options,
        ],
      };

    case SET_ACTIVE_DASHBOARD:
      const { id } = action.payload;
      return {
        ...state,
        reportActiveDashboard: id,
      };

    case RESET_ACTIVE_DASHBOARD:
      return {
        ...state,
        reportActiveDashboard: initailState.reportActiveDashboard,
      };

    case SET_REPORT_DASHBOARD_DATA:
      const { data } = action.payload;
      return {
        ...state,
        reportDashboard: data,
      };

    case SET_SLOT_UPDATING:
      const { slotId } = action.payload;
      return {
        ...state,
        reportDashboard: {
          ...state.reportDashboard,
          dashboard_slots: setSlotUpdate(state.reportDashboard.dashboard_slots, slotId, true),
        }
      };

    case SET_ALL_REFRESHING:
      const { dashboardId } = action.payload;
      return {
        ...state,
        reportDashboard: setDashboardUpate(state.reportDashboard, dashboardId, true),
      };

    case SET_SLOT_DATA:
      const { updateSlotId, slotData } = action.payload;
      return {
        ...state,
        reportDashboard: {
          ...state.reportDashboard,
          dashboard_slots: setSlotData(updateSlotId, state.reportDashboard.dashboard_slots, slotData),
        }
      };

    case RESET_DASHBOARD:
      return {
        ...state,
        reportOptions: initailState.reportOptions,
        reportActiveDashboard: initailState.reportActiveDashboard,
        reportDashboard: initailState.reportDashboard,
      };

    default:
      return state;
  }
};
export default dashboard;




// WEBPACK FOOTER //
// ./src/views/Dashboard/flow/reducer.js